var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconListView = function SvgIconListView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 89 96",
    id: "vector",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M 5 0 L 20 0 C 21.326 0 22.598 0.527 23.536 1.464 C 24.473 2.402 25 3.674 25 5 L 25 20 C 25 21.326 24.473 22.598 23.536 23.536 C 22.598 24.473 21.326 25 20 25 L 5 25 C 3.674 25 2.402 24.473 1.464 23.536 C 0.527 22.598 0 21.326 0 20 L 0 5 C 0 3.674 0.527 2.402 1.464 1.464 C 2.402 0.527 3.674 0 5 0 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path_1",
    d: "M 35 2 L 85 2 C 86.06 2 87.079 2.422 87.828 3.172 C 88.578 3.921 89 4.94 89 6 L 89 6 C 89 7.06 88.578 8.079 87.828 8.828 C 87.079 9.578 86.06 10 85 10 L 35 10 C 33.94 10 32.921 9.578 32.172 8.828 C 31.422 8.079 31 7.06 31 6 L 31 6 C 31 4.94 31.422 3.921 32.172 3.172 C 32.921 2.422 33.94 2 35 2 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path_2",
    d: "M 35 13 L 56 13 C 57.06 13 58.079 13.422 58.828 14.172 C 59.578 14.921 60 15.94 60 17 L 60 17 C 60 18.06 59.578 19.079 58.828 19.828 C 58.079 20.578 57.06 21 56 21 L 35 21 C 33.94 21 32.921 20.578 32.172 19.828 C 31.422 19.079 31 18.06 31 17 L 31 17 C 31 15.94 31.422 14.921 32.172 14.172 C 32.921 13.422 33.94 13 35 13 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path_3",
    d: "M 5 36 L 20 36 C 21.326 36 22.598 36.527 23.536 37.464 C 24.473 38.402 25 39.674 25 41 L 25 56 C 25 57.326 24.473 58.598 23.536 59.536 C 22.598 60.473 21.326 61 20 61 L 5 61 C 3.674 61 2.402 60.473 1.464 59.536 C 0.527 58.598 0 57.326 0 56 L 0 41 C 0 39.674 0.527 38.402 1.464 37.464 C 2.402 36.527 3.674 36 5 36 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path_4",
    d: "M 35 38 L 85 38 C 86.06 38 87.079 38.422 87.828 39.172 C 88.578 39.921 89 40.94 89 42 L 89 42 C 89 43.06 88.578 44.079 87.828 44.828 C 87.079 45.578 86.06 46 85 46 L 35 46 C 33.94 46 32.921 45.578 32.172 44.828 C 31.422 44.079 31 43.06 31 42 L 31 42 C 31 40.94 31.422 39.921 32.172 39.172 C 32.921 38.422 33.94 38 35 38 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path_5",
    d: "M 35 49 L 56 49 C 57.06 49 58.079 49.422 58.828 50.172 C 59.578 50.921 60 51.94 60 53 L 60 53 C 60 54.06 59.578 55.079 58.828 55.828 C 58.079 56.578 57.06 57 56 57 L 35 57 C 33.94 57 32.921 56.578 32.172 55.828 C 31.422 55.079 31 54.06 31 53 L 31 53 C 31 51.94 31.422 50.921 32.172 50.172 C 32.921 49.422 33.94 49 35 49 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path_6",
    d: "M 5 71 L 20 71 C 21.326 71 22.598 71.527 23.536 72.464 C 24.473 73.402 25 74.674 25 76 L 25 91 C 25 92.326 24.473 93.598 23.536 94.536 C 22.598 95.473 21.326 96 20 96 L 5 96 C 3.674 96 2.402 95.473 1.464 94.536 C 0.527 93.598 0 92.326 0 91 L 0 76 C 0 74.674 0.527 73.402 1.464 72.464 C 2.402 71.527 3.674 71 5 71 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path_7",
    d: "M 35 73 L 85 73 C 86.06 73 87.079 73.422 87.828 74.172 C 88.578 74.921 89 75.94 89 77 L 89 77 C 89 78.06 88.578 79.079 87.828 79.828 C 87.079 80.578 86.06 81 85 81 L 35 81 C 33.94 81 32.921 80.578 32.172 79.828 C 31.422 79.079 31 78.06 31 77 L 31 77 C 31 75.94 31.422 74.921 32.172 74.172 C 32.921 73.422 33.94 73 35 73 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path_8",
    d: "M 35 84 L 56 84 C 57.06 84 58.079 84.422 58.828 85.172 C 59.578 85.921 60 86.94 60 88 L 60 88 C 60 89.06 59.578 90.079 58.828 90.828 C 58.079 91.578 57.06 92 56 92 L 35 92 C 33.94 92 32.921 91.578 32.172 90.828 C 31.422 90.079 31 89.06 31 88 L 31 88 C 31 86.94 31.422 85.921 32.172 85.172 C 32.921 84.422 33.94 84 35 84 Z",
    fill: "#d8d8d8",
    stroke: "#00000000",
    strokeWidth: 1
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconListView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_list_view.2f807996.svg";
export { ForwardRef as ReactComponent };